import enUSJSON from '../../scripts/langs/en-US.json'
import enCAJSON from '../../scripts/langs/en-CA.json'
import enAUJSON from '../../scripts/langs/en-AU.json'
import esJSON from '../../scripts/langs/es-ES.json'
import fnJSON from '../../scripts/langs/fn-FN.json'
import ptJSON from '../../scripts/langs/pt-BR.json'
import ruJSON from '../../scripts/langs/ru-RU.json'
import { default as frJS } from './fr'
import { default as esJS } from './es'
import { default as enJS } from './en'
import { default as ruJS } from './ru'
import { default as ptJS } from './pt'

const enUS = {...enJS, ...enUSJSON.HEF_Translations}
const enCA = {...enJS, ...enCAJSON.HEF_Translations}
const enAU = {...enJS, ...enAUJSON.HEF_Translations}

export const fr = {...frJS, ...fnJSON.HEF_Translations}
export const es = {...esJS, ...esJSON.HEF_Translations}
export const ru = {...ruJS, ...ruJSON.HEF_Translations}
export const pt = {...ptJS, ...ptJSON.HEF_Translations}

export const en = {
  'en-US': enUS,
  'en-CA': enCA,
  'en-AU': enAU,
}
